import { get, has } from '@/utilities/helpers';

export default class Model {
	private static exposedProps: Map<Function, Set<string>> = new Map();
	public constructor(data: any = {}) {
		this.initialize(data);
	}

	public initialize(data: any = {}) {
		Object.keys(data).forEach((key: string) => {
			if (has(key)(this)) {
				(this as any)[key] = get(key, data);
			}
		});
	}

	static addExposedProps(target: any, propertyKey: string) {
		const constructor = target.constructor;
		if (!Model.exposedProps.has(constructor)) {
			Model.exposedProps.set(constructor, new Set());
		}
		Model.exposedProps.get(constructor)!.add(propertyKey);
	}

	static getExposedProps(instance: any): Set<string> {
		return Model.exposedProps.get(instance.constructor) || new Set();
	}

	public printSafeObject(): Partial<Model> {
		const results: Partial<Model> = {};
		const include = Model.getExposedProps(this);

		for (const key of Object.keys(this)) {
			if (!include.has(key)) {
				continue;
			}

			const value = (this as any)[key];
			if (Array.isArray(value)) {
				const res = value.map((item) => {
					if (item instanceof Model) {
						return item.printSafeObject();
					}
					return item;
				}) as any;
				results[key as keyof Model] = res;
			} else if (value instanceof Model) {
				results[key as keyof Model] = value.printSafeObject() as any;
			} else {
				results[key as keyof Model] = (this as any)[key];
			}
		}
		return results;
	}
}

export function Expose(target: any, propertyKey: string) {
	Model.addExposedProps(target, propertyKey);
}
